import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TemplateCategory } from '../models/template.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface TemplateCategoryDrawerOptions {
  categoryId?: string;
}

@Injectable({ providedIn: 'root' })
export class TemplateCategoryDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$$ = new BehaviorSubject<{
    isOpen: boolean;
    options: TemplateCategoryDrawerOptions;
  }>({ isOpen: false, options: {} });

  private readonly saved$$ = new Subject<TemplateCategory>();

  readonly state = this.state$$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: TemplateCategoryDrawerOptions = {}): void {
    if (!this.state$$.value.isOpen) this.registry.opened();
    this.state$$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$$.value.isOpen) this.registry.closed();
    this.state$$.next({ isOpen: false, options: {} });
  }

  notifySaved(item: TemplateCategory): void {
    this.saved$$.next(item);
  }
}
